<template>
	<div v-if="user === 'client'">
		<client-settings-nav-component></client-settings-nav-component>

		<router-view></router-view>
	</div>

	<div v-else>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				user: this.$store.getters.user.type
			};
		}
	};
</script>